<template>
  <div class="custhSlider">
    <hooper 
      :itemsToShow="1.2" 
      :centerMode="true"
      :itemsToSlide="1" 
      pagination="yes" 
      :infiniteScroll="true" 
      :autoPlay="true" 
      :playSpeed="6000" 
      style="height:height:300px">
      <slide v-for="(img, i) in images" :key="'prods-' + i" :index="i" style="height:300px;">
        <img :src="img" width="99%">
      </slide>
      <hooper-navigation slot="hooper-addons"></hooper-navigation>
      <hooper-pagination slot="hooper-addons"></hooper-pagination>
    </hooper>
  </div>
</template>

<script>
import { Hooper, Slide, Pagination as HooperPagination,
  Navigation as HooperNavigation } from 'hooper';
import 'hooper/dist/hooper.css';
export default {
  components: {
    Hooper,
    Slide,
    HooperPagination,
    HooperNavigation
  },
  data() {
    return {
      images: []
    }
  },
  props:['loading'],
  methods: {
    reload(){
      this.$emit('reload')
    },
    addToCart(product) {
      this.$store.dispatch('addToCart', product)
    },
    async loadSlides() {
      this.images = await this.$store.dispatch('getResource', { resource: `/dashboard/slides?width=${window.screen.width}`})
    }
  },
  async mounted() {
    await this.loadSlides()
  }
}
</script>

<style>
.custhSlider .hooper-list,
.custhSlider .hooper,
.custhSlider .hooper-track,
.custhSlider .hooper-slide,
.custhSlider {
  direction: ltr !important;
}
.revDirection * {
  direction: rtl !important;
  text-align: right;
}
.custhSlider .hooper-list,
.custhSlider .hooper,
.custhSlider {
  height:300px;
}
.custhSlider .hooper-list {
  height:300px;
}
</style>